export default __webpack_public_path__ + "static/media/easy-to-use.3b65a5de.svg";